module.exports = __webpack_public_path__ + "img/dialing.b352d3fd.gif";